import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { retrieveToken } from "../../../utils/storage";

export const serviziApi = createApi({
  reducerPath: "servizi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["services", "service", "groups", "group"],
  endpoints: (builder) => ({
    getServices: builder.query({
      query: (body) => ({
        url: `/admin/practiceservices/list`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: body,
      }),
      providesTags: ["services"],
    }),
    getServiceId: builder.query({
      query: (id) => ({
        url: "/admin/practiceservices/" + id,
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      providesTags: ["service"],
    }),
    createService: builder.mutation({
      query: (service) => ({
        url: `/admin/practiceservices`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: service,
      }),
      invalidatesTags: ["services", "service"],
    }),
    suggestStudioServices: builder.mutation({
      query: (service) => ({
        url: "/admin/practiceservices/suggestservice",
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: service,
      }),
    }),
    deleteService: builder.mutation({
      query: (id) => ({
        url: `/admin/practiceservices/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: { id },
      }),
      invalidatesTags: ["services"],
    }),
    editService: builder.mutation({
      query: (service) => ({
        url: `/admin/practiceservices/${service.id}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: service,
      }),
      invalidatesTags: ["services", "service"],
    }),
    updateService: builder.mutation({
      query: (service) => ({
        url: `/admin/Studio/updateservice`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: service,
      }),
      invalidatesTags: ["services", "service"],
    }),
    requestService: builder.mutation({
      query: (data) => ({
        url: `/admin/practiceservices/requestservice`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: data,
      }),
      //invalidatesTags: ["services", "service"],
    }),
    addService: builder.mutation({
      query: (data) => ({
        url: `/admin/Studio/addservice`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: data,
      }),
      invalidatesTags: ["services", "service"],
    }),
    removeService: builder.mutation({
      query: (data) => ({
        url: `/admin/Studio/removeservice`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: data,
      }),
      invalidatesTags: ["services", "service"],
    }),
    getUploadURL: builder.query({
      query: () => ({
        url: "/admin/practiceservices/getuploadurl",
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),
    getServiceGroup: builder.query({
      query: (studioId) => ({
        url: `admin/PracticeServiceCategory${studioId ? `?studioId=${studioId}` : ''}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      providesTags: ["groups"]
    }),
    getServiceGroupId: builder.query({
      query: (id) => ({
        url: `admin/PracticeServiceCategory/${id}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      providesTags: ["group"]
    }),
    createServiceGroup: builder.mutation({
      query: (group) => ({
        url: `admin/PracticeServiceCategory`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: group,
      }),
      invalidatesTags: ["group", "groups", "services", "service"]
    }),
    deleteServiceGroup: builder.mutation({
      query: (id) => ({
        url: `admin/PracticeServiceCategory/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      invalidatesTags: ["group", "groups"]
    }),
    editServiceGroup: builder.mutation({
      query: (group) => ({
        url: `admin/PracticeServiceCategory/${group.id}?name=${group.name}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: group,
      }),
      invalidatesTags: ["group", "groups"]
    }),
    addServiceGroup: builder.mutation({
      query: ({ group }) => ({
        url: `admin/PracticeServiceCategory/${group.idCategory}/practice-service/${group.idPracticeService}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: group,
      }),
      invalidatesTags: ["group", "groups", "services", "service"]
    }),
    removeServiceGroup: builder.mutation({
      query: (id) => ({
        url: "admin/PracticeServiceCategory/practice-service/" + id,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      invalidatesTags: ["group", "groups", "services", "service"]
    }),
  }),
});

export const {
  useGetServicesQuery,
  useGetServiceIdQuery,
  useCreateServiceMutation,
  useEditServiceMutation,
  useDeleteServiceMutation,
  useGetUploadURLQuery,
  useSuggestStudioServicesMutation,
  useRequestServiceMutation,
  useAddServiceMutation,
  useRemoveServiceMutation,
  useUpdateServiceMutation,
  useGetServiceGroupQuery,
  useGetServiceGroupIdQuery,
  useCreateServiceGroupMutation,
  useRemoveServiceGroupMutation,
  useEditServiceGroupMutation,
  useAddServiceGroupMutation,
  useDeleteServiceGroupMutation
} = serviziApi;
